var Aneox;
(function (Aneox) {
  (function (Sequences) {
    'use strict';

    var SavoirFaire = (function () {

      var self;
      var animations;
      var timeline;

      var hasPlayedThroughAnimation = {};

      function SavoirFaire(anims) {
        self = this;
        animations = anims;
        
        timeline = new TimelineMax({ paused: true });

        timeline
        .add(new animations.OpeningTimeline($('#savoir-faire-opening')))
        .addPause()
        .addLabel('viticulture')
        .add(animations.SubtitleTimeline($('#viticulture-title')))
        .add(animations.ImgTimeline($('#viticulture-img-wrapper')), 'viticulture+=.5')
        .add(animations.BorderBoxTimeline($('#viticulture-text')), '-=.5')
        .addPause()
        .addLabel('viticulture-closing')
        .add(animations.SubtitleTimeline($('#viticulture-closing-text')))
        .add(animations.SubtitleTimeline($('#viticulture-button-gallery')), 'viticulture-closing')
        .addPause()
        .addLabel('vinification')
        .call(function() {
          setTimeout(function() {
            $('.eye').removeAttr('style');
          }, 500);
        })
        .add(animations.BorderBoxTimeline($('#vinification-main'), true))
        .add(animations.SubtitleTimeline($('#vinification-title')), 'vinification')
        .add(animations.ImgTimeline($('#vinification-img-wrapper')), 'vinification+=.5')
        .addPause()
        .addLabel('vinification-text')
        .add(animations.TextTimeline($('#vinification-text')))
        .addPause()
        .addLabel('vinification-closing')
        .add(animations.SubtitleTimeline($('#vinification-closing-text')));
      }

      SavoirFaire.prototype.mastEnterAnimation = function() {
        timeline.play();
      };

      SavoirFaire.prototype.viticultureEnterAnimation = function() {
        if (timeline.time() > timeline.getLabelTime('viticulture')) return;
        timeline.seek('viticulture').play();
      };

      SavoirFaire.prototype.viticultureClosingAnimation = function() {
        if (timeline.time() > timeline.getLabelTime('viticulture-closing')) return;
        timeline.seek('viticulture-closing').play();
      };

      SavoirFaire.prototype.vinificationEnterAnimation = function() {
        if (timeline.time() > timeline.getLabelTime('vinification')) return;
        timeline.seek('vinification').play();
      };

      SavoirFaire.prototype.vinificationTextAnimation = function() {
        if (timeline.time() > timeline.getLabelTime('vinification-text')) return;
        timeline.seek('vinification-text').play();
      };

      SavoirFaire.prototype.vinificationClosingAnimation = function() {
        if (timeline.time() > timeline.getLabelTime('vinification-closing')) return;
        timeline.seek('vinification-closing').play();
      };

      SavoirFaire.prototype.fastForwardAnimations = function() {
        timeline.pause().progress(1);
      };

      SavoirFaire.prototype.resetAnimations = function() {
        timeline.pause().progress(0);
      }

      SavoirFaire.prototype.handleWindowResize = function(bodyWidth, bodyHeight) {

      };


      return SavoirFaire;
    })();

    Sequences.SavoirFaire = SavoirFaire;
  })(Aneox.Sequences || (Aneox.Sequences = {}));
})(Aneox || (Aneox = {}));